'use client';

import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const MyAliceChat = dynamic(() => import('@/features/MyAliceChat'), {
  ssr: false,
  // You can add a placeholder with a fixed height here too for extra safety
  loading: () => <div style={{ minHeight: '174px' }} />,
});

export default function LazyMyAliceChat() {
  const [showChat, setShowChat] = useState(false);

  const pathname = usePathname();

  useEffect(() => {
    if (showChat) {
      return;
    }

    const handleInteraction = () => {
      setShowChat(true);
    };

    const listenerOptions = { passive: true, once: true };

    // Listen for the first interaction
    window.addEventListener('scroll', handleInteraction, listenerOptions);
    window.addEventListener('mousemove', handleInteraction, listenerOptions);
    window.addEventListener('touchstart', handleInteraction, listenerOptions);

    // Fallback timer in case the user doesn't interact
    const timer = setTimeout(() => {
      handleInteraction();
    }, 5000); // 5 seconds

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, []);

  // Do not render if on /chat page
  if (pathname === '/chat') {
    return null;
  }

  return showChat ? <MyAliceChat /> : null;
}
